import $ from 'jquery';
import FontFaceObserver from 'fontfaceobserver';
import getSvgFonts from 'svg-config/src/js/utils/getSvgFonts';
import SVGEdit from 'svg-config/src/js/components/SVGEdit';

$.fn.extend({
  svgConfigEdit({ onShow, onChange } = {}) {
    const $img = this.filter('[data-svg-url]');

    if ($img.length === 0) {
      return;
    }

    const svgUrl = $img.data('svgUrl');
    const svgPersonalized = $img.data('svgPersonalized');

    const $modal = $('#svg-config-edit-modal');

    const svgEdit = new SVGEdit({
      svgView: '#svg-config-edit-svg-view',
      controlView: '#svg-config-edit-control-view',
      photoUrl: window.si_data.broker.photoThumbnail || window.si_data.broker.placeholder,
      logoUrl: window.si_data.agency.logo || '',
      content: {
        ...(window.si_data.agency ? {
          aname: window.si_data.agency.corporateName,
          aphone: window.si_data.agency.telephone,
          aurl: window.si_data.agency.website,
        } : {}),
        ...(svgPersonalized ? {} : {
          bmail: window.si_data.broker.email,
          bphone: window.si_data.broker.telephone,
          burl: window.si_data.broker.website,
          fname: window.si_data.broker.firstName,
          lname: window.si_data.broker.lastName,
          name: window.si_data.broker.name,
          title: window.si_data.broker.title,
        }),
        date: window.si_data.microtext,
      },
    });

    $modal.modal({
      closable: false,
      onApprove() {
        svgEdit.getSVG()
          .then((svgString) => {
            const data = new FormData();
            data.set('svg_file', new Blob([svgString], { type: 'image/svg+xml' }), 'template.svg');

            $.ajax({
              url: $img.data('svgSaveUrl'),
              method: 'POST',
              data,
              processData: false,
              contentType: false,
              dataType: 'json',
              success({ svgUrl: savedSvgUrl }) {
                $img.data('svgUrl', savedSvgUrl);
                $img.attr('data-svg-url', savedSvgUrl);

                $img.data('svgPersonalized', true);
                $img.attr('data-svg-personalized', true);

                $img.svgConfigView();

                $modal.modal('hide');
                $modal.find('.dimmer').removeClass('active');

                if (onChange) {
                  onChange(svgEdit);
                }
              },
            });
          });

        $modal.find('.dimmer').addClass('active');

        return false;
      },
      onHidden() {
        $(svgEdit.$svgView).html('');
        $(svgEdit.$controlView).html('');
      },
    });
    $modal.find('.actions .ui.button.approve').addClass('disabled');
    $modal.modal('show');

      fetch(svgUrl, { mode: 'cors' })
      .then(response => response.text())
      .then(svgString => (
        Promise.all(getSvgFonts(svgString).map(font => (
          new FontFaceObserver(font).load()
            .then(() => undefined, () => { throw font; })
        )))
          .then(() => svgEdit.load(svgUrl), (font) => {
            // a font could not be loaded
            // todo: notify the product owner?
            throw font;
          })
          .then(() => {
            $modal.modal('refresh');
            $modal.find('.actions .ui.button.approve').removeClass('disabled');

            if (onShow) {
              onShow(svgEdit);
            }
          })
      ));
  },
});
